export default __webpack_public_path__ + "static/media/Campus.2d8af8e5.svg";